import { Component, EventEmitter, Injector, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AppComponentBase } from '@shared/app-component-base';
import { AlergiaServiceProxy, CreateAlergiaDto } from '@shared/service-proxies/service-proxies';
import { StringUtils } from '@shared/helpers/StringUtils';
import { finalize } from '@node_modules/rxjs/operators';
import { TipoAlergiaList } from "@shared/model/tipo-alergia-enum.model"

@Component({
  selector: 'app-create-alergia',
  templateUrl: './create-alergia.component.html',
  styleUrls: ['./create-alergia.component.scss']
})
export class CreateAlergiaComponent extends AppComponentBase {

  protected alergia: CreateAlergiaDto = new CreateAlergiaDto();
  protected saving: boolean = false;
  protected tiposAlergias: TipoAlergiaList = new TipoAlergiaList();
   @Output() onSave = new EventEmitter<any>();

  constructor(
    injector: Injector,
    private readonly _alergiaService: AlergiaServiceProxy,
    public bsModalRef: BsModalRef
  ) { super(injector) }

  protected save(): void {
    if (!this.isFormValided()) return;
    abp.ui.setBusy();
    this.saving = true;
    this._alergiaService.create(this.alergia).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.saving = false;
      this.onSave.emit();
      this.bsModalRef.hide();
    })
  }

  private isFormValided(): boolean {
    var validations = [
      { condition: StringUtils.isNullOrEmpty(this.alergia.substancia), message: "Informe a substância ou agente causador." },
      { condition: StringUtils.isNullOrEmpty(this.alergia.tipoAlergia), message: "Informe o tipo da alergia." },
    ];

    for (const validation of validations) {
      if (validation.condition) {
        this.notify.warn(this.l(validation.message));
        return false;
      }
    }

    return true;
  }
}
